(() => {
  const TYPE_TEXT = 'ZAYRO';

  function enableHeroTyping() {
    const hero = document.querySelector('main .hero');
    if (!hero || hero.dataset.zayroTypingReady === 'true') return;

    const container = hero.querySelector('.hero__container');
    if (!container) return;

    hero.dataset.zayroTypingReady = 'true';
    hero.classList.add('zayro-typing-hero');

    const type = document.createElement('div');
    type.className = 'zayro-hero-type';
    type.setAttribute('aria-label', TYPE_TEXT);
    type.innerHTML = '<span class="zayro-hero-type__text" aria-hidden="true"></span><span class="zayro-hero-type__caret" aria-hidden="true"></span>';
    container.append(type);

    const textNode = type.querySelector('.zayro-hero-type__text');
    const reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    if (reduceMotion) {
      textNode.textContent = TYPE_TEXT;
      hero.classList.add('zayro-typing-complete');
      return;
    }

    let index = 0;
    const typeNext = () => {
      index += 1;
      textNode.textContent = TYPE_TEXT.slice(0, index);
      if (index < TYPE_TEXT.length) {
        window.setTimeout(typeNext, 145);
      } else {
        window.setTimeout(() => hero.classList.add('zayro-typing-complete'), 260);
      }
    };

    window.setTimeout(typeNext, 280);
  }

  function addProductFaqs() {
    if (!document.querySelector('product-information')) return;
    if (document.querySelector('.zayro-product-faqs')) return;

    const main = document.querySelector('main');
    if (!main) return;

    const section = document.createElement('section');
    section.className = 'zayro-product-faqs';
    section.setAttribute('aria-labelledby', 'zayro-faq-heading');
    section.innerHTML = `
      <div class="zayro-product-faqs__inner">
        <h2 class="zayro-product-faqs__heading" id="zayro-faq-heading">Frequently Asked Questions</h2>

        <details class="zayro-product-faqs__item">
          <summary class="zayro-product-faqs__question">Do you offer Cash on Delivery?</summary>
          <div class="zayro-product-faqs__answer">Yes. Cash on Delivery is available for orders within Pakistan.</div>
        </details>

        <details class="zayro-product-faqs__item">
          <summary class="zayro-product-faqs__question">When do I get free delivery?</summary>
          <div class="zayro-product-faqs__answer">Orders above Rs. 5,000 qualify for free delivery.</div>
        </details>

        <details class="zayro-product-faqs__item">
          <summary class="zayro-product-faqs__question">Can I return my watch?</summary>
          <div class="zayro-product-faqs__answer">You can request a return within 15 days of delivery. Contact us with your order details to start the return process.</div>
        </details>

        <details class="zayro-product-faqs__item">
          <summary class="zayro-product-faqs__question">How do I choose a watch color?</summary>
          <div class="zayro-product-faqs__answer">If a watch has multiple colors, select the color circle before adding it to cart. Your selected color is saved with the order.</div>
        </details>

        <details class="zayro-product-faqs__item">
          <summary class="zayro-product-faqs__question">How should I care for my watch?</summary>
          <div class="zayro-product-faqs__answer">Keep your watch away from strong chemicals and avoid exposing it to water unless that watch's product description specifically states that it is water resistant.</div>
        </details>
      </div>
    `;

    main.append(section);
  }

  function polishJudgeMe() {
    const widget = document.querySelector('#judgeme_product_reviews');
    if (!widget) return;
    const section = widget.closest('.zayro-reviews-section');
    if (section) section.classList.add('zayro-judgeme-polished');
  }

  function initialize() {
    enableHeroTyping();
    addProductFaqs();
    polishJudgeMe();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initialize, { once: true });
  } else {
    initialize();
  }

  document.addEventListener('shopify:section:load', () => {
    window.setTimeout(initialize, 0);
  });

  const observer = new MutationObserver(() => {
    if (document.querySelector('product-information') && !document.querySelector('.zayro-product-faqs')) {
      addProductFaqs();
    }
    if (document.querySelector('#judgeme_product_reviews')) polishJudgeMe();
  });
  observer.observe(document.documentElement, { childList: true, subtree: true });
})();
